import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const DollarBill = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="17"
        height="13"
        viewBox="0 0 17 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.2877 7.383C0.837695 6.7 0.837695 5.801 1.2877 5.118C2.3057 3.575 4.5497 1 8.1997 1C11.8497 1 14.0947 3.574 15.1117 5.118C15.5617 5.801 15.5617 6.7 15.1117 7.383C14.0937 8.926 11.8497 11.501 8.1997 11.501C4.5497 11.501 2.3047 8.927 1.2877 7.383Z"
          stroke="#ADACA8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.2002 8.5C9.44284 8.5 10.4502 7.49264 10.4502 6.25C10.4502 5.00736 9.44284 4 8.2002 4C6.95755 4 5.9502 5.00736 5.9502 6.25C5.9502 7.49264 6.95755 8.5 8.2002 8.5Z"
          fill="#ADACA8"
          stroke="#ADACA8"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

export default DollarBill
